import React from "react";
import Navbar from "../Components/Navbar";
import { isMobile } from "react-device-detect";
import Footer from "../Components/Footer";
import { motion } from "motion/react";
import Core from "../Components/Core";

const Special = () => {
  return (
    <div>
      <Navbar />

      {/* HERO SECTION */}
      <section className="bg-white pb-lg-8 pb-6 px-lg-6 px-0">
        <div className="container">
          <div className="row pt-lg-10 pt-6 align-items-center">

            {/* TEXT */}
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="col-lg-6 mb-6 mb-lg-0"
            >
              <div className="text-muted text-uppercase mb-2 fs-6">
                Inclusive & Personalized Learning
              </div>
              <div className="fs-m fw-semibold text-dark mb-4">
                Special Needs Education Program
              </div>

              <div
                className={`fs-5 text-dark ${
                  isMobile ? "px-3" : "text-justify"
                }`}
              >
                At Ebun Heritage Schools, we believe that every child is uniquely
                gifted and deserves the opportunity to thrive in a supportive,
                structured, and nurturing environment.
                <br /><br />
                Our Special Needs Program is designed to provide individualized
                educational support for students with diverse learning needs,
                developmental challenges, and exceptional abilities.
                <br /><br />
                We are committed to inclusion, dignity, patience, and excellence —
                ensuring that every learner is empowered to reach their fullest
                God-given potential.
              </div>
            </motion.div>

            {/* IMAGE */}
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="col-lg-6 text-center"
            >
              <img
                src="../../assets/images/background/spe1.png"
                alt="Special Needs Education"
                width={500}
                className="img-fluid"
              />
            </motion.div>

          </div>
        </div>
      </section>

      {/* SERVICES SECTION */}
      <section className="bg-back py-lg-10 py-6">
        <div className="container">
          <div className="text-center mb-6">
            <div className="fs-m fw-semibold text-dark">Our Specialized Support Services</div>
            <p className="text-muted fs-5">
              We provide structured, evidence-based interventions tailored to each child’s needs.
            </p>
          </div>

          <div className="row g-4">
            {[
              {
                title: "Individualized Education Plans (IEPs)",
                desc: "Each student receives a personalized learning plan tailored to their strengths, challenges, pace, and developmental goals."
              },
              {
                title: "Speech & Language Support",
                desc: "Targeted interventions to improve communication skills, articulation, comprehension, and expressive abilities."
              },
              {
                title: "Behavioral & Emotional Support",
                desc: "Structured guidance to help students develop self-regulation, emotional resilience, and positive social behavior."
              },
              {
                title: "Learning Disabilities Support",
                desc: "Specialized teaching strategies for students with dyslexia, ADHD, autism spectrum conditions, and other learning differences."
              },
              {
                title: "Small Group & One-on-One Instruction",
                desc: "Focused teaching environments that ensure personalized attention and measurable progress."
              },
              {
                title: "Life Skills & Functional Training",
                desc: "Practical training in independence, daily living skills, social interaction, and confidence-building."
              }
            ].map((item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="col-md-6 col-lg-4"
              >
                <div className="card border-0 shadow-sm p-4 h-100" style={{ borderRadius: "20px" }}>
                  <h5 className="fw-semibold mb-3 text-dark">{item.title}</h5>
                  <p className="text-muted">{item.desc}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* APPROACH SECTION */}
      <section className="bg-white py-lg-10 py-6">
        <div className="container">
          <div className="row align-items-center">

            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="col-lg-6 mb-5 mb-lg-0"
            >
              <div className="fs-m fw-semibold text-dark mb-4">Our Holistic Approach</div>
              <p className="fs-5 text-muted text-justify">
                We adopt a collaborative, multidisciplinary approach involving
                educators, therapists, counselors, and parents.
                <br /><br />
                Our classrooms are structured yet flexible, allowing adaptive
                teaching techniques, sensory-friendly environments, and
                differentiated instruction strategies.
                <br /><br />
                We emphasize patience, compassion, faith-based values, and
                measurable academic growth — ensuring every child progresses
                confidently at their own pace.
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="col-lg-6 text-center"
            >
              <img
                src="../../assets/images/background/spe2.png"
                alt="Holistic Education"
                width={500}
                className="img-fluid"
              />
            </motion.div>

          </div>
        </div>
      </section>

      {/* CONTACT + GOAL SECTION */}
                  <section className="bg-back pt-lg-6 pt-8 pb-lg-6 pb-4 px-lg-6 px-0">
                      <div className="container">
      
                          {/* Contact Card */}
                          <motion.div
                              initial={{ opacity: 0, y: 40 }}
                              whileInView={{ opacity: 1, y: 0 }}
                              transition={{ duration: 0.8 }}
                              viewport={{ once: true }}
                              className="px-lg-18 mt-lg-n14 mt-n8"
                          >
                              <div className="card shadow-lg bg-dark-blue p-4 p-lg-6" style={{ borderRadius: '30px' }}>
                                  <div className="d-lg-flex text-center justify-content-center">
      
                                      <div>
                                          <div className="fs-5 text-white">Get In Touch:</div>
                                          <div className="fs-3 text-white">
                                              admin@ebunheritageschool.com
                                          </div>
                                      </div>
      
                                      <div className="mx-4">
                                      <button className="btn btn-icon btn-white shadow-lg fw-semibold py-4 px-4 fs-5 rounded-circle">
                                          OR
                                      </button>
                                      </div>
      
                                      <div>
                                          <div className="fs-5 text-white">Call Us Via:</div>
                                          <div className="fs-3 text-white">
                                          +234 906 216 8062
                                          </div>
                                      </div>
      
                                  </div>
                              </div>
                          </motion.div>
      
      
                          {/* Our Goal Section */}
                          <div className="row align-items-center pt-lg-10 pt-6 pb-lg-6 px-lg-0">
      
                              <motion.div
                                  initial={{ opacity: 0, x: -50 }}
                                  whileInView={{ opacity: 1, x: 0 }}
                                  transition={{ duration: 0.8 }}
                                  viewport={{ once: true }}
                                  className="col-lg-6 mb-6 mb-lg-0"
                              >
                                  <div className="fs-t2 text-gray-800 fw-semibold mb-lg-4 mb-4 text-lg-start text-center">
                                      Our <u className="text-primary"><span className="text-dark-blue">Goal.</span></u>
                                  </div>
      
                                  <div className={`fs-4 text-dark ${isMobile ? 'px-4' : 'text-justify'}`}>
                                      At Ebun Heritage Schools, our goal is to harness the God-given potentials in every child,
                                      guiding them to discover purpose, excellence, and integrity from an early age.
                                      <br /><br />
                                      We aim to cultivate academic brilliance, moral discipline, spiritual growth,
                                      and leadership qualities within a safe and dynamic learning environment.
                                      Our creche and pre-school lay the foundation for confident, responsible,
                                      and globally minded learners who will positively impact their communities and the world.
                                  </div>
                              </motion.div>
      
                              <motion.div
                                  initial={{ opacity: 0, scale: 0.8 }}
                                  whileInView={{ opacity: 1, scale: 1 }}
                                  transition={{ duration: 0.8 }}
                                  viewport={{ once: true }}
                                  className="col-lg-6 text-center"
                              >
                                  <img
                                      src="../../assets/images/background/value.png"
                                      alt="Ebun Heritage Goal"
                                      width={500}
                                      className="img-fluid mb-lg-4"
                                  />
                              </motion.div>
      
                          </div>
                      </div>
                  </section>

      <Core />
      <Footer />
    </div>
  );
};

export default Special;
